const TYPE = "motivoFinalizacao";

const motivoFinalizacaoModule = {
  findAll: async (dbConnection) => {
    let motivos = [];
  
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE }
      },
      limit: 50000,
    });

    if (result.docs.length) {
      motivos = result.docs;
    }

    return motivos;
  },

};
export default motivoFinalizacaoModule;
